import { LinkWallPin, TextWallPinData, WALL_PIN_TYPE, WallPin } from '~/models/WallPin'
import { WallPinService } from '~/services/trip/wallPin/service'
import { TranslationService } from '~/services/Translation'
import EventsService from '~/services/events'
import { Page } from '~/models/PaginatedItems'
import { Profile } from '~/models/Profile'
import MediaService from '~/passporter-services/media/service'
import { mediaCache } from '~/passporter-services/media/cache'
import Media from '~/models/Media'

export class WallPinActions {
	static async createTextWallPin(tripId: string, textData: TextWallPinData): Promise<WallPin> {
		try {
			const wallPin: WallPin = {
				type: WALL_PIN_TYPE.TEXT,
				data: textData,
			}
			return await WallPinService.createWallPin(tripId, wallPin)
		} catch {
			throw Error('not_saved')
		}
	}

	static async createWallPin(tripId: string, wallPin: LinkWallPin): Promise<WallPin> {
		try {
			return await WallPinService.createWallPin(tripId, wallPin)
		} catch {
			throw Error('not_saved')
		}
	}

	static buildMediaWallPin(): WallPin {
		return {
			type: WALL_PIN_TYPE.MEDIA,
			data: {
				id: '',
			} as Media,
		}
	}

	static async createMediaWallPin(tripId: string, files: File[]): Promise<void> {
		try {
			const medias = await MediaService.uploadMultipleImages(files)
			mediaCache.setMedias(medias, files)
			for (const media of medias) {
				const wallPin: WallPin = {
					type: WALL_PIN_TYPE.MEDIA,
					data: media,
				}
				await WallPinService.createWallPin(tripId, wallPin)
			}
		} catch {
			throw Error('not_saved')
		}
	}

	static async updateTextWallPin(
		tripId: string,
		wallPinId: string,
		textData: TextWallPinData
	): Promise<WallPin> {
		try {
			return await WallPinService.updateTextData(tripId, wallPinId, textData)
		} catch {
			throw Error('not_saved')
		}
	}

	static buildLinkWallPin(url: string, owner?: Profile): LinkWallPin {
		return {
			type: WALL_PIN_TYPE.LINK,
			data: { url },
			owner: owner,
		}
	}

	static async getWallPins(
		tripId: string,
		page?: number,
		pageSize?: number
	): Promise<Page<WallPin>> {
		try {
			return await WallPinService.getWallPins(tripId, page, pageSize)
		} catch (e) {
			console.error(e)
			return { items: [] }
		}
	}

	static async deleteWallPins(tripId: string, wallPinId: string): Promise<void> {
		const t = TranslationService.getInstance()
		try {
			await WallPinService.deleteWallPin(tripId, wallPinId)
			EventsService.emitSuccess(t.translate('web.board.toast.note_deleted_success'))
		} catch {
			EventsService.emitError(t.translate('web.board.toast.error_delete_note'))
		}
	}

	static clearWallPins(tripId: string): void {
		try {
			WallPinService.clearPins(tripId)
		} catch (e) {
			console.error(e)
		}
	}
}
